import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-util-js/FunUtil';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

var fn = function fn($rootScope, $state, $translate, $scope, $q, $stateParams, AccountService, PolicyService, RenewalService, ActivityService, $modal, $window, ModalService, $filter, UserService, TranslateService, InsuranceSuiteMetadata, ReinstatementService, ViewModelService, GPA_PC_ENTRY_POINT, SubmissionService) {
    var ctrl = Object.create(BaseCtrl);
    var SupportedTransactionLOBs = ['BOPLine', 'CPLine'];

    ctrl.init = function () {
        /**
         * Prevent users from entering the transaction screen by clicking back button    	 
         */
        $rootScope.allowPolicyChangeEvent = false;
        $rootScope.restrictNavigationStatus = false;
        $window.scrollTo(0, 0);
        $rootScope.hidePolicyDetails = false;
        /**
            * Service call to get policy details for the specified policy number which is taken from the URL
            * display policy details if policy number exist, if not display relevant error message
            * @param ("policyNumber", "policy number which has been initiated from Portal")
            * @return ("policyDTO", Object) contains all policy and account related details
            */
        var policyRequest = PolicyService.getPolicy($stateParams.policyNumber);
        policyRequest.then(function (policy) {
            $scope.currentPolicyData = policy;
        }, function () {});
        /**
         * Service call to find whether the policy has MLE or not
         * If the policy is MLE then return message to display relevant information on the screen
         * @param ("policyNumber", "policyNumber which has been initiated from portal") 
         * @return ("existsMLEPolicy", return true if the given policy number has MLE) 
         */
        PolicyService.checkMLEPolicy($stateParams.policyNumber).then(function (res) {

            $scope.MLEPolicy = res;
            if (res == true) {
                $scope.formIsOpen = true;
                $scope.MLEmsg = 'test';
                return $scope.MLEmsg;
            }
        });
        /**
         * Translations to display policy change options when click on Policy Change button
         */
        $scope.Policychange = $filter('translate')('gateway.controllers.policy.policychange.Change Employers Liability Limit') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation') + "\n" + $filter('translate')('directives.policy-change.Estimated Wages') + "\n" + $filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation') + "\n" + $filter('translate')('policy.common.directives.mailingAddress');

        /**
         * Translations to display policy request options when click on Policy Request button
         */
        $scope.Requestpolicy = $filter('translate')('gateway.controllers.policy.policychange.Backdated Cancellation') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Business Information Change') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Extra Territorial Petition') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Medical Deductible') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Other States Coverage') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Owner/Officer Change') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Add/Remove Elective Endorsement') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Remove Class Code') + "\n" + $filter('translate')('gateway.controllers.policy.policychange.Other');

        if ($rootScope.CCAdded == "CCAdded") {
            $scope.closeInfo = true;
            clearSubmittedMessages();
            $scope.CCAdded = true;
            $rootScope.CCAdded = "";$rootScope.SWOS = "";$rootScope.Bound = "";$rootScope.policyBound = false;
        }
        if ($rootScope.SWOS == "swosSubmitted") {
            $scope.closeInfo = true;
            clearSubmittedMessages();
            $scope.swosSubmitted = true;
            $rootScope.SWOS = "";$rootScope.Bound = "";$rootScope.policyBound = false;
        }
        if ($rootScope.Bound == "policyBound") {
            $scope.closeInfo = true;
            clearSubmittedMessages();
            $scope.polBound = true;
            $rootScope.SWOS = "";$rootScope.Bound = "";$rootScope.policyBound = false;
        }
        if ($rootScope.withdrawSubmitted == true) {
            $scope.closeInfo = true;
            clearSubmittedMessages();
            $scope.withdrawSubmitted = true;
            $rootScope.SWOS = "";$rootScope.Bound = "";$rootScope.policyBound = false;
        }
        if ($rootScope.policyBound == true) {
            $scope.closeInfo = true;
            clearSubmittedMessages();
            $scope.polBound = true;$;
            $rootScope.SWOS = "";$rootScope.policyBound = false;
        }
        initialiseScopeVariables();

        /**
         * service call to retrieve the per capita class codes for the given policy number
         * push class code to the percapita class array variable
         * @param ("policyNumber", "policynumber which has been initiated from portal")
         * @return ("perCapitaClassCodes", "returned percapita class codes for the given policy number")
         */
        PolicyService.getPerCapitaCodesByPolicyNumber($stateParams.policyNumber).then(function (datas) {

            $scope.perCapitaClasses = [];
            if (datas.length > 0) {
                angular.forEach(datas, function (data) {
                    $scope.perCapitaClasses.push(data.classCode);
                });
            }
        });
        //Execute the main method
        policyPeriodTerm($stateParams.policyNumber);
    };

    /**
     * Assigning policy number and description to the policy change
     */
    $scope.policyChange = {
        'policyNumber': $scope.policyNumber,
        'effectiveDate': '',
        'description': 'Portal Side Policy Change'
    };

    /**
     * Method to trigger construction credit policy change for the current term
     */
    $scope.currentCCPolicyChange = function () {

        $scope.triggerCCPolicyChange($scope.policyData);
    };

    /**
     * method to get the renewal period for the particular policy number 
     * check the renewal exist, if true trigger construction credit draft policy change
     * if not, trigger construction credit policy change by passing renewal period
     * @param ("policyNumber", "initiated from Portal")
     * @return ("PolicyPeriodDTO", "return the data for the renewal period contains effective date, totalPremium,status and expirationDate")
     */
    $scope.renewalCCPolicyChange = function () {
        var fetchRenewalData = PolicyService.getRenewalPeriodData($scope.policyNumber);
        fetchRenewalData.then(function (data) {
            var periodData = data;
            periodData.effective = data.effectiveDate;
            if (data.msfRenewalExistsForSurvey_EXT === true) {
                //Execute the main method
                $scope.triggerCCDraftPolicyChange(periodData);
            } else {
                //Execute the main method
                $scope.triggerCCPolicyChange(periodData);
            }
        });
    };

    /**
     * Main method that gets called to check whether construction credit is already submitted or not
     * service call returns boolean value, if construction credit is not yet submitted earlier for the policy number then it will allow to submit
     * if it is already submitted then throws the relevant information on the screen
     * @param ("policyNumber", "policy number which has been initiated from portal")
     * @param ("effectiveDate", "effective date of the policy change")
     * @param ("jobNumber", "jobNumber initiated from the portal") 
     * @return ("data","string result which will identify whether construction credit can be advanced")
     */
    $scope.triggerCCDraftPolicyChange = function (periodData) {
        $scope.disableSubmit = true;
        $scope.canCCAdvance = false;
        var constructionCreditAdvance;
        $scope.policyChange.effectiveDate = moment(periodData.effective).format('YYYY-MM-DD');

        $scope.policyChange.description = "Construction Credit Update";

        var credit = PolicyService.checkConstructionCreditAdvance($scope.policyNumber, $scope.policyChange.effectiveDate, periodData.mSFJobNumber);
        credit.then(function (data) {
            if (data == "false") {

                if (periodData.mSFJobNumber != undefined) {
                    $state.go('construction-credit', {
                        policyNumber: $stateParams.policyNumber,
                        jobNumber: periodData.mSFJobNumber
                    });
                }
            } else if (data == "true") {

                ModalService.showInfo('', 'There is an existing construction credit application in progress, please contact Montana State Fund to assist with your request.');
            } else if (data != null && data != "") {
                $state.go('construction-credit', {
                    policyNumber: $stateParams.policyNumber,
                    jobNumber: data
                });
            }
        });
        PolicyService.callEUTS('Policy Details', 'Construction Credit', $scope.policyNumber);
    };
    /**
     * Method to create new policy change transaction when construction credit application is submitted
     * If existing CC is not there, then it will create a new transaction
     * if not, throws an information to CC screen
     * @param ("policyNumber", "policy number which has been initiated from portal")
    * @param ("effectiveDate", "effective date of the policy change")
    * @param ("jobNumber", "jobNumber initiated from the portal") 
    * @return ("data","string result which will identify whether construction credit can be advanced")
     */
    $scope.triggerCCPolicyChange = function (periodData) {
        $scope.disableSubmit = true;
        $scope.canCCAdvance = false;
        var constructionCreditAdvance;
        $scope.policyChange.effectiveDate = moment(periodData.effective).format('YYYY-MM-DD');

        $scope.policyChange.description = "Construction Credit Update";

        var credit = PolicyService.checkConstructionCreditAdvance($scope.policyNumber, $scope.policyChange.effectiveDate);
        credit.then(function (data) {

            if (data == "false") {
                /**
                 * @param ("policyChange", "Object contains effectiveDate and Description")
                 * @return ("JobDTO" Object)
                 */
                var newPolicyChangeRequest = PolicyService.createNewPolicyChangeTransaction($scope.policyChange);
                newPolicyChangeRequest.then(function (job) {

                    $scope.jobNumber = job.JobNumber;
                    if (job.jobNumber != undefined) {
                        $state.go('construction-credit', {
                            policyNumber: $stateParams.policyNumber,
                            jobNumber: job.jobNumber
                        });
                    }
                }, function (error) {});
            } else if (data == "true") {

                ModalService.showInfo('', 'There is an existing construction credit application in progress, please contact Montana State Fund to assist with your request.');
            } else if (data != null && data != "") {
                //Existing construction Credit which was not submitted
                $state.go('construction-credit', {
                    policyNumber: $stateParams.policyNumber,
                    jobNumber: data
                });
            }
        });
        PolicyService.callEUTS('Policy Details', 'Construction Credit', $scope.policyNumber);
    };

    $scope.payrollLink = function () {
        PolicyService.callEUTS('Policy Details', 'Payroll Reporting', $scope.policyNumber);
    };

    /**
     * Main method that gets called to get pending reinstatement details for the given policy number
     * @param ("policyNumber", "policyNumber which has been initiated from portal")
     * @return ("jobNumber", returns jobNumber if pending reinstatement has been found)
     */
    function checkForPendingReinstatement(policyNumber) {

        $scope.reinstatementPromise = ReinstatementService.getPendingReinstatement(policyNumber);

        $q.when($scope.reinstatementPromise, function (jobNumber) {
            if (!jobNumber) {
                //if the policy is pending reinstatement,then it will show the reinstatement form_MSF
                $scope.showReinstatementForm = true;
                return;
            }
            $state.transitionTo('reinstatement.detail.summary', { reinstatementNumber: jobNumber });
        }, function (error) {
            ModalService.showError('Error', $q.when(error.baseError.data.error.message));
        });
    }

    $scope.reinstatementRequest = {
        'policyNumber': $scope.policyNumber,
        'reason': '',
        'description': ''
    };

    function mapReinstatementDetails(reinstatement) {

        $scope.reinstatement = reinstatement;
        $scope.latestPeriod = reinstatement.policy.latestPeriod;

        $scope.policyNumber = reinstatement.policy.policyNumber;

        $scope.createTime = reinstatement.createTime;
        $scope.reinstatementReason = InsuranceSuiteMetadata.get('pc').types.getTypelist('ReinstateCode').getCode(reinstatement.reason).name;
        $scope.reinstatementDescription = reinstatement.description;
        $scope.reinstatementIsDraft = reinstatement.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name;

        if (!$scope.reinstatementDescription) {
            $scope.reinstatementDescription = '-';
        }
    }
    /**
     * Method to call the service for start the reinstatement when it is submitted from portal
     * Added logic to show loader till the result comes after submit
     * @param ("reinstatementRequest", "ReinstatementDTO")
     * @return ("ReinstatementDTO" Object)
     */
    ctrl.bindReinstatement = function (form) {
        var message = $translate('gateway.views.reinstatement-detail.You won\'t be able to undo once bound.').then(function (msg) {
            return $translate('gateway.views.reinstatement-detail.Are you sure you want to bind this reinstatement?').then(function (secondMsg) {

                return '' + secondMsg;
            });
        });
        $scope.bindReinstatementLoader = true;

        $scope.reinstatementPromise = ReinstatementService.startReinstatement($scope.reinstatementRequest);
        $q.when($scope.reinstatementPromise, function (reinstatement) {
            $scope.bindReinstatementLoader = false;
            if (reinstatement.policy) {
                /**
                 * TO get the reinstatement details and assign them to scope variable to display the values 
                 */
                mapReinstatementDetails(reinstatement);
                $state.transitionTo('reinstatement.detail.summary', { reinstatementNumber: reinstatement.jobNumber });
            } else {
                ctrl.hideReinstateForm();
            }
        }, function (error) {
            /**
             * Handle to display error message when reinstatement service call gets failed
             */
            $scope.bindReinstatementLoader = false;
            ModalService.showError(' ', error.baseError.error.message + '.');
        });
    };
    /**
     * viewmodelservice is used to create an instance of the DTO 
     */
    $scope.reinstatementView = ViewModelService.create($scope.reinstatementRequest, 'pc', 'edge.capabilities.gateway.job.reinstatement.dto.ReinstatementDTO');

    $scope.reasonCodes = $scope.reinstatementView.reason.aspects.availableValues;

    /**
     * function to initialize the scope variables for policy transaction table config and activity table config
     * configuring meta data template for document
     */
    function initialiseScopeVariables() {
        $scope.showReinstatementForm = false;
        $scope.disableCancelBtn = false;
        $scope.policyTransactionTableConfig = {
            transactionStatus: '',
            policyTransactionStatus: [],
            source: 'account',
            search: ''
        };
        //execute the main method
        getPolicyTransactionStatus();

        $scope.activityTableConfig = {
            actStatus: 'allOpen',
            defaultActStatus: 'allOpen',
            actStatusOptions: {
                'allOpen': 'gateway.directives.ActivitySummary.All Open',
                'allClosed': 'gateway.directives.ActivitySummary.All Closed',
                'overdue': 'gateway.directives.ActivitySummary.Overdue',
                'openAssignedToMe': 'gateway.directives.ActivitySummary.Open, Assigned to me'
            },
            showAddActivity: false
        };

        $scope.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved',
            policyNumber: $stateParams.policyNumber
        };

        $scope.policyNumber = $stateParams.policyNumber;
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
        $scope.changeFormIsVisible = false;
        $scope.renewFormIsVisible = false;

        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.enableClaims = applicationFeatures.gatewayclaims === 'true';
        $scope.gatewayEndorsementEnabled = applicationFeatures.gatewayendorsement === 'true';
    }
    /**
     * Main function that gets called to get status of the policy transaction
     * assigning values and display key for the status, 
     * By default assigning the status as Draft for the policy transaction
     */
    function getPolicyTransactionStatus() {
        var status = [{
            value: 'all',
            name: '',
            displayKey: 'gateway.views.account-detail.All'
        }, {
            value: 'Draft',
            name: '',
            displayKey: 'typekey.PolicyPeriodStatus.Draft'
        }];
        //Execute the main method
        $scope.policyTransactionTableConfig.policyTransactionStatus = translatePolicyTransactionStatuses(status);
        $scope.policyTransactionTableConfig.transactionStatus = status[0];
    }

    /**
     * Main function that gets called to translate the policy transaction status
     * @param ("statuses", "all and draft status are passing")
     * @return ("statuses", "translated the statuses using TranslateService and return the statuses")
     */
    function translatePolicyTransactionStatuses(statuses) {
        statuses.forEach(function (status) {
            TranslateService.translate({
                object: status,
                propName: 'name',
                displayKey: status.displayKey,
                scope: $scope
            });
        });

        return statuses;
    }

    ctrl.showAddActivity = function () {
        $scope.activityTableConfig.showAddActivity = true;
    };

    /**
     * Method to get the boolean value of the activity from the service call
     * Used to display the activity button based on the boolean result
     * @param ("permissionDTO", "actcreate permission has been passed to hasUserSystemPermission service call")
     * @return ("showAddActivityButton", "based on the response assigning boolean value to scope object") 
     */
    ctrl.shouldShowAddActivityButton = function () {
        var permissionDTO = {
            permission: 'actcreate'
        };

        var actPromise = UserService.hasUserSystemPermission(permissionDTO);

        actPromise.then(function (showActivity) {
            $scope.showAddActivityButton = showActivity;
        });
    };

    ctrl.shouldShowAddActivityButton();

    /**
     * Method to get the boolean value of the activity from the service call
     * Used to display the cancellation button based on the boolean result
     * @param ("permissionDTO", "advancecancellation permission has been passed to hasUserSystemPermission service call")
     * @return ("canAdvanceCancellation", "based on the response assigning boolean value to scope object") 
     */
    ctrl.hasAdvanceCancellationPermission = function () {
        UserService.hasUserSystemPermission({
            permission: 'advancecancellation'
        }).then(function (canAdvanceCancellation) {
            $scope.canAdvanceCancellation = canAdvanceCancellation;
        });
    };
    ctrl.hasAdvanceCancellationPermission();

    ctrl.goBackOne = function () {
        window.history.back();
    };

    /**
     * Method to retrieve all activities for the policy 
     * @param ("policyNumber","policyNumber which has been initiated from portal")
     * @return ("ActivityDTO[]", Array)
     */
    ctrl.getActivities = function () {
        return ActivityService.getActivitiesForPolicy($stateParams.policyNumber);
    };

    ctrl.showCancellationForm = function () {
        clearSubmittedMessages();
        $rootScope.policyBound = false;
        $scope.polBound = false;
        $scope.renewalComplete = false;
        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;
        $scope.cancelFormIsVisible = true;
        PolicyService.callEUTS('Policy Details', 'Cancel Policy', $scope.policyNumber);
    };

    ctrl.hideCancellationForm = function () {
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
    };

    /**
     * Method to check whether the policy has pending reinstatement or not_MSF when click the request reinstatement button  
     */
    ctrl.toggleShowReinstatementForm = function () {
        //execute the main method
        checkForPendingReinstatement($scope.policyNumber);
        PolicyService.callEUTS('Policy Details', 'Reinstatement', $scope.policyNumber);
    };

    /**
     * Method to show the renewal payroll form 
     * Get the Job details based on the job number and calculate basis amount 
     * @param ("jobNumber", "jobNumber which has been initiated from portal")
     * @return ("ReinstatementDataDTO", Object)
     */
    ctrl.showRenewalPayrollForm = function () {
        clearSubmittedMessages();
        $rootScope.hidePolicyDetails = true;
        $rootScope.policyBound = false;
        $scope.polBound = false;
        $scope.renewalComplete = false;
        if ($scope.formIsOpen) {
            return;
        }

        RenewalService.findJobByJobNumber($scope.latestPeriod.msfRenewalNumberForSurvey_EXT).then(function (data) {
            data.mSFLocations = $filter('orderBy')(data.mSFLocations, 'locationNum', false);
            $scope.periodData = data.latestPeriod;

            if ($scope.periodData.mSFWCCoveredEmployees.length > 0 && $scope.periodData.mSFAddWCCoveredEmployees.length > 0) {
                $scope.period = [];
                angular.forEach(data.latestPeriod.mSFWCCoveredEmployees, function (allVersions) {
                    if (data.latestPeriod.mSFAddWCCoveredEmployees != undefined) {
                        angular.forEach(data.latestPeriod.mSFAddWCCoveredEmployees, function (additionalVersions) {
                            if (allVersions.classCode.code == additionalVersions.classCode.code) {
                                var totalbasisAmount = allVersions.basisAmount + additionalVersions.basisAmount;
                                if (totalbasisAmount != undefined && totalbasisAmount != null && !Number.isNaN(totalbasisAmount)) {
                                    allVersions.basisAmount = totalbasisAmount;
                                }
                            }
                        });
                    }
                    $scope.period.push(allVersions);
                });

                $scope.periodData.mSFWCCoveredEmployees = $scope.period;
            }
            data.mSFWCCoveredEmployees = $scope.periodData.mSFWCCoveredEmployees;
            $scope.renewalData = data;

            $scope.formIsOpen = true;
            $scope.payrollFormIsVisible = true;
            /**
             * For displaying current details section after submitting renewal payroll survey from portal
             */
            $rootScope.hidePolicyDetails = false;
        });

        PolicyService.callEUTS('Policy Details', 'Renewal Payroll Survey', $scope.policyNumber);
    };
    /**
     * Method to hide the renewal payroll survey form 
     */
    ctrl.hideRenewalPayrollForm = function () {
        $scope.formIsOpen = false;
        $scope.payrollFormIsVisible = false;
        $rootScope.hidePolicyDetails = false;
    };
    /**
     * Display request form for requesting policy change
     */
    ctrl.showRequestForm = function () {
        clearSubmittedMessages();
        $rootScope.policyBound = false;
        $scope.polBound = false;
        $scope.renewalComplete = false;

        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;
        $scope.requestFormIsVisible = true;
        PolicyService.callEUTS('Policy Details', 'Request Policy Change', $scope.policyNumber);
    };
    $scope.$on("requestSubmitted", function () {
        $scope.formIsOpen = false;
        $scope.requestFormIsVisible = false;
        $scope.requestSubmitted = true;
    });
    $scope.$on("withdrawSubmitted", function () {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
        $scope.withdrawSubmitted = true;
    });
    $scope.$on("hideWithdrawSection", function () {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
    });

    ctrl.hideRequestForm = function () {
        clearSubmittedMessages();
        $scope.formIsOpen = false;
        $scope.requestFormIsVisible = false;
    };

    ctrl.showChangeForm = function () {
        clearSubmittedMessages();
        $rootScope.policyBound = false;
        $scope.polBound = false;
        $scope.renewalComplete = false;
        if ($scope.formIsOpen) {
            return;
        }

        var lobCode = $scope.latestPeriod.policyLines[0].lineOfBusinessCode;
        if ($scope.gatewayEndorsementEnabled && ApplicationFeatures.hasFeature('endorsement-products.' + lobCode)) {
            var nextPage = SupportedTransactionLOBs.includes(lobCode) ? 'endorsementTransactionEntry' : 'endorsementWithPolicy';

            $state.transitionTo(nextPage, {
                selectedPolicyNumber: $scope.policyNumber
            });
        } else {

            if ($scope.MLEPolicy == false) {
                $scope.formIsOpen = true;
                $scope.changeFormIsVisible = true;
            }
        }
        PolicyService.callEUTS('Policy Details', 'Change Policy', $scope.policyNumber);
    };

    ctrl.hideChangeForm = function () {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
    };

    $scope.hideForm = function () {
        $window.location.reload();
    };
    /**
     * Method to show Renew form by assigning true boolean value to scope object
     */
    ctrl.showRenewForm = function () {
        clearSubmittedMessages();
        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;
        $scope.renewFormIsVisible = true;
    };

    /**
     * Method to hide Renew form by assigning false boolean value to scope object
     */
    ctrl.hideRenewForm = function () {
        clearSubmittedMessages();
        $scope.formIsOpen = false;
        $scope.renewFormIsVisible = false;
    };

    ctrl.hideReinstateForm = function () {
        clearSubmittedMessages();
        $scope.formIsOpen = false;
        $scope.showReinstatementForm = false;
    };
    ctrl.showPayrollForm = function () {
        clearSubmittedMessages();
        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;

        $state.go('payroll-details', {
            policyNumber: $scope.policyNumber
        });
    };

    /**
     * Method to create a new transaction for policy renewal 
     * @param ("policyNumber", "policyNumber which has been initiated from portal")
     * @return ("JobDTO", "Object")
     */
    ctrl.createPolicyRenewalTransaction = function () {
        if ($scope.formIsOpen) {
            return;
        }

        var lobCode = $scope.latestPeriod.policyLines[0].lineOfBusinessCode;
        var newPolicyRenewalRequest = PolicyService.createNewPolicyRenewalTransaction($stateParams.policyNumber);
    };
    /**
     * Method to save the covered employee details to PC
     * Create a custom history event after updating the covered employee details to PC
     * @param ("jobNumber","jobNumber which has been initiated from portal")
     * @param ("coveredEmployees", "MSFSpecificWCCoveredEmployeeDTO_Ext[]")
     * @param ("existingRecords", "MSFSpecificWCCoveredEmployeeDTO_Ext[]")
     * @param ("subject","setting subject as Renewal Payroll Survey")
     * @param ("description","setting description as Renewal: Review the class code(s) added as part of Renewal Payroll Survey.")
     * @return ("SpecificRenewalDTO", Object)
     */
    ctrl.saveCoveredEmployees = function (data) {
        RenewalService.updateCoveredEmployees($scope.latestPeriod.msfRenewalNumberForSurvey_EXT, data.portalcoveredEmployees, data.existingEmployees, 'Renewal Payroll Survey ', 'Renewal: Review the class code(s) added as part of Renewal Payroll Survey.').then(function (data) {
            data.mSFLocations = $filter('orderBy')(data.mSFLocations, 'locationNum', false);
            $scope.renewalData = data;
            $scope.formIsOpen = false;
            $scope.payrollFormIsVisible = false;
            $scope.renewalComplete = true;

            PolicyService.createCustomHistoryEvent($scope.latestPeriod.msfRenewalNumberForSurvey_EXT, 'MSFRenewalSurvey').then(function (data) {});
        }, function () {
            ModalService.showError('Unable to save Covered Employees', 'An error occurred while attempting to save Covered Employees.');
        });
    };
    ctrl.selectedTerm = function (termKey, period) {
        $scope.disableCancelBtn = termKey == 'renewal';
        $scope.selectedPeriod = period;
    };
    /**
     * Show policy details based on condition
     */
    $scope.showPolicyDetails = function () {
        if ($scope.changeFormIsVisible || $scope.requestFormIsVisible || $scope.cancelFormIsVisible || $scope.reinstateFormIsVisible || $scope.hidePolicyDetails || $scope.payrollFormIsVisible) return false;else return true;
    };

    return ctrl.create($scope);

    function clearSubmittedMessages() {
        $scope.policyBound = false;
        $scope.CCAdded = false;
        $scope.swosSubmitted = false;
        $scope.requestSubmitted = false;
        $scope.withdrawSubmitted = false;
        $rootScope.withdrawSubmitted = false;
    }

    /**
     * Main method that gets called to get the current term and renewed term of the policy
     * @param ("policyNumber", "policy Number which has been initiated from portal")
     * @return ("PolicyDetailsDTO", "Object")
     */
    function policyPeriodTerm(policyNumber) {
        var policyDetails = PolicyService.getAccountPolicyDetails(policyNumber);
        $q.when(policyDetails, function (policyData) {
            /**
             * Assigning current Period as initial selected period
             */
            $scope.selectedPeriod = policyData.currentPeriod;

            $scope.policyData = policyData.currentPeriod;
            $scope.policyDataRenewal = policyData.renewedPeriod;
            $scope.periods = [{
                title: 'policy.common.views.account-policy-details.Current',
                data: $scope.policyData,
                buttonText: 'policy.common.views.account-policy-details.Change Current Policy',
                key: 'current'
            }];

            if ($scope.policyDataRenewal) {
                /**
                 * Push renewal data to the period if policy has renewal term
                 */
                $scope.periods.push({
                    title: 'policy.common.views.account-policy-details.Renewing',
                    data: $scope.policyDataRenewal,
                    buttonText: 'policy.common.views.account-policy-details.Change Renewal Policy',
                    key: 'renewal'
                });
            }
        });
    }
};
fn.$inject = ['$rootScope', '$state', '$translate', '$scope', '$q', '$stateParams', 'AccountService', 'PolicyService', 'RenewalService', 'ActivityService', '$modal', '$window', 'ModalService', '$filter', 'UserService', 'TranslateService', 'InsuranceSuiteMetadata', 'ReinstatementService', 'ViewModelService', 'GPA_PC_ENTRY_POINT', 'SubmissionService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/policy/PolicySummaryCtrl.js
// module id = 1711
// module chunks = 0